<template>
 <div class="user-main">
   <div v-if="hasResult">
     <header class="user-header">
       <h1 class="user-header__logo"><img src="../assets/images/logo.jpg" alt="" @click="onResetData" class="user-header__logo-img mr-2">임마누엘교회 버스노선 조회</h1>
       <v-form
         ref="form"
         class="user-header-form"
       >
         <div class="justify-end  d-flex ">
           <a href="https://cafe.naver.com/immanuelseoul/47" class="user-header__link v-btn v-btn--depressed v-btn--outlined v-size--small indigo--text">요청하기</a>
         </div>
         <v-radio-group v-model="search.toChurch" row hide-details class="mt-0">
           <v-radio
             v-for="(item, index) in distance"
             :key="index"
             :label="item.name"
             :value="item.value"
             class="mb-1"
           ></v-radio>
         </v-radio-group>
         <v-select
           v-model="search.parish"
           label="근거리/교구"
           :items="parishList"
           hide-details
           class="mb-3"
         ></v-select>
         <v-text-field
           hide-details
           v-model="search.stop"
           label="정차장소"
           class="mb-5"
         ></v-text-field>
         <v-btn
           color="primary"
           @click="routeTo"
           class="mt-9"
           depressed
           rounded
           block
           large
         >
           검색
         </v-btn>
       </v-form>
     </header>
     <div class="user-result-content">
       <table class="user-result-table" v-if="displayData && displayData.length > 0">
         <colgroup>
           <col style="width: 30%">
           <col style="width: 70%">
         </colgroup>
         <thead>
         <tr>
           <th>교구/노선</th>
           <th>정차장소(시간)</th>
         </tr>
         </thead>
         <tbody>
           <tr
             v-for="(route, i) in displayData"
             :key="i"
           >
             <td>
               <b>&lt;{{ route.parish }}&gt;</b> <br>
               {{ route.name }}
             </td>
             <td>
               <div
                 v-for="(dis, i) in route.busDispatches"
                 :key="i"
                 class="bus-station-set"
               >
                 <b class="bus-name">{{ dis.bus && dis.bus.name }}</b>
                 <p
                   v-for="(station, i) in dis.stations"
                   :key="i"
                   class="station-name"
                 >
                   {{ station.station.name }} ({{ String(station.hour).padStart(2,'0') }}:{{ String(station.min).padStart(2,'0') }})
                   <v-btn
                     color="red"
                     outlined
                     class="map-button"
                     @click="openMap(station.station.lat, station.station.lng)"
                   >
                     지도
                   </v-btn>
                 </p>
               </div>
             </td>
           </tr>
         </tbody>
       </table>
        <p class="no--result-data" v-else-if="displayData && displayData.length === 0">
          검색결과가 없습니다.
        </p>
     </div>
     <v-dialog v-model="map.showModal">
       <map-station
         :location-data="map.locationData"
         @closeModal="closeMap"
       />
     </v-dialog>
   </div>
   <div class="user-result-fail" v-else>
     <p>정보를 가져오지 못했습니다.<br> 아래버튼을 눌러주세요.</p>
     <v-btn
       color="secondary"
       @click="fetchData"
       class="mt-7"
       depressed
       rounded
       large
     >
       재시도
     </v-btn>
   </div>
 </div>
</template>
<script>
import { advertise, allInfo } from '@/api'
import eventBus from '@/utils/eventBus'
import MapStation from '../components/map/MapStation'

export default {
  name: 'Main',
  components: {
    MapStation
  },
  data () {
    return {
      distance: [
        { name: '교회행', value: true },
        { name: '현장행', value: false }
      ],
      search: {
        toChurch: true,
        parish: null,
        stop: ''
      },
      rawData: null,
      displayData: null,
      hasResult: true,
      map: {
        showModal: false,
        locationData: {
          lat: 37.4788755,
          lng: 127.1271389
        }
      }
    }
  },
  computed: {
    parishList () {
      if (!this.rawData) return []
      return this.rawData.groups.reduce((prev, x) => {
        return prev.concat({ text: x.name, value: x.name })
      }, [{ text: '전체', value: '' }])
    }
  },
  created () {
    const meta = document.createElement('meta')
    meta.name = 'viewport'
    meta.content = 'width=device-width, user-scalable=no'
    document.getElementsByTagName('head')[0].appendChild(meta)
    this.checkLocationAd()
  },
  async mounted () {
    await this.fetchData()
    this.setSearchFromQuery()
  },
  methods: {
    onResetData () {
      this.displayData = null
      this.search.toChurch = true
      this.search.parish = null
      this.search.stop = ''
    },
    async fetchData () {
      try {
        eventBus.$emit('showLoading')
        const { data } = await allInfo.route()
        this.rawData = data
        this.hasResult = true
      } catch (e) {
        this.hasResult = false
      } finally {
        eventBus.$emit('hideLoading')
      }
    },
    setSearchFromQuery () {
      const { toChurch, parish, stop } = this.$route.query
      if (toChurch !== undefined && toChurch !== '') {
        this.search.toChurch = Boolean(toChurch)
      }
      if (parish) {
        const searchedParish = this.parishList.find(x => x.value === parish)
        this.search.parish = searchedParish ? searchedParish.value : ''
      }
      if (stop) {
        this.search.stop = stop
      }
      this.onSubmit()
    },
    routeTo () {
      this.$router.push({
        path: '',
        query: {
          toChurch: this.search.toChurch,
          parish: this.search.parish,
          stop: this.search.stop
        }
      })
        .catch(() => {})
      this.onSubmit()
    },
    onSubmit () {
      // 교구필터
      let ret = this.rawData.groups
      if (this.search.parish) {
        ret = ret.filter(group => group.name === this.search.parish)
      }
      let routes = ret.reduce((prev, group) => {
        const routes = group.routes.map(route => {
          route.parish = group.name
          return route
        })
        return prev.concat(routes)
      }, [])
      // 방향필터
      routes = routes.reduce((prev, route) => {
        const targetDispatches = route.busDispatches.filter(busDispatch => busDispatch.toChurch === this.search.toChurch)
        if (targetDispatches.length > 0) {
          route.busDispatches = targetDispatches
          return prev.concat(route)
        }
        return prev
      }, [])
      // 키워드 필터
      if (this.search.stop) {
        routes = routes.filter(route => {
          return route.busDispatches.some(busDispatch => {
            return busDispatch.stations.some(station => station.station.name.includes(this.search.stop))
          })
        })
      }
      this.displayData = routes
    },
    openMap (lat, lng) {
      this.map.locationData.lat = lat
      this.map.locationData.lng = lng
      this.map.showModal = true
    },
    closeMap () {
      this.map.showModal = false
    },
    async checkLocationAd () {
      const { data } = await advertise.getLocation()
      console.log('data.visible: ' + data.visible)
      if (data.visible === true) {
        let title = data.text0
        title = title.replace(/\n/gi, '<br/>')
        let text = data.text1
        text = text.replace(/\n/gi, '<br/>')
        eventBus.$emit('dialog',
          {
            active: true,
            msgTitle: title,
            msg: text,
            okText: '확인',
            confirmHandler: {
              ok: () => {
                // nothing to do
              }
            }
          }
        )
      }
    }
  }
}
</script>
<style lang="scss">
  .row.contents.user-contents {
    padding-top: 0;
    background: #ffffff;
    font-size: 18px;
  }
  .user-main {
    width: 100%;
    .user-header__link {
      color: #222222;
    }
  }
  .user-header {
    padding: 0;
    text-align: center;
    margin-bottom: 2rem;
    &__logo {
      font-size: 1.2em;
      padding: 1.5rem 1rem 1rem;
      font-weight: 500;
      &-img {
        width: 40px;
        vertical-align: middle;
        cursor: pointer;
      }
    }
    &__link {
    }
    &-form {
      width: 90%;
      margin-left: 5%;
      padding: 1.5rem 2rem;
      background: #fff;
      border: 1px solid #ddd;
      border-radius: 20px;
      .v-btn__content {
        font-size: 1.1em;
      }
    }
  }
  .user-result-content {
    background: #ffffff;
    padding: 0 1rem 2rem;
    .no--result-data {
      text-align: center;
      margin-top: 4rem;
      font-size: 1.1rem;
    }
  }
  .user-result-fail {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
  }
  .user-result-table {
    width: 100%;
    border-collapse: collapse;
    th{
      background: #f3f3f3;
      color: #222;
      padding: 0.5rem;
      text-align: center;
      font-weight: normal;
      &:first-child {
        border-right: 1px solid #dddddd;
      }
    }
    tr{
      &:first-child {
        td{
          border-top: 0;
        }
      }
    }
    td {
      word-break: keep-all;
      border: 1px solid #ddd;
      padding: 0 .5rem;
      &:first-child {
        text-align: center;
      }
    }
  }
  .bus-station-set {
    padding: 0.8rem;
    @media all and (max-width: 380px) {
      padding: 0.8rem 0;
    }
    border-radius: 10px;
    .bus-name {
    }
    .station-name {
      margin: 0;
      font-size: 17px;
      & +.station-name {
        &:before {
          content: '↓';
          display: block;
          font-size: 0.8rem;
          opacity: .8;
        }
      }
    }
    &:nth-child(even) {
      background: rgb(32 63 100 / 7%);
    }
  }
.station-name {
  .v-btn.map-button {
    min-width: auto;
    padding: 3px 8px;
    height: auto;
    display: block;
  }
}

</style>
